import { __decorate } from "tslib";
import { Component, Mixins, Inject, Watch } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import ShippingMethodManager from '@/components/v2/ShippingMethodManager.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ShippingFormThirdParty from '@/components/v2/ShippingFormThirdParty.vue';
import RateCard from '@/components/v2/RateCard.vue';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { ShippingMethodThirdPartyProvider } from '@/helpers/entities/enums/v2/ShippingMethodThirdPartyProvider';
import { SHOPIFY } from '@/helpers/constants/CustomBundleKeys';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import SyncShippingRates from '@/plugins/graphql/mutations/v2/shopify/sync-shipping-rates.gql';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import AppShopifySetting from '@/plugins/graphql/queries/app-shopify-setting.gql';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import ConfirmationDialog from '@/components/BaseConfirmDialog.vue';
import JntDetails from '@/plugins/graphql/queries/v2/jnt-account.gql';
import { JntAccountInputModel } from '@/helpers/entities/models/JntAccountInputModel';
import JntExpressActivationForm from '@/components/v2/JntExpressActivationForm.vue';
import JntExpressDisconnectionForm from '@/components/v2/JntExpressDisconnectionForm.vue';
import jntAccountSubscription from '@/plugins/graphql/subscriptions/v2/jnt-account-update.gql';
import moment from 'moment';
let ShippingMethods = class ShippingMethods extends Mixins(Mixins(ViewportSizeMixin, RouterParamsAppMixin, AlertMixin, ButtonLoaderMixin, GraphqlErrorMixin), CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.thirdPartyShippingFormHeader = '';
        this.shopifySetting = null;
        this.jntAccount = null;
        this.toggleConfirm = false;
    }
    refetchShipping() {
        const vm = this;
        vm.$refs.shipping.refetchShippingMethods();
    }
    get shopifyAppUuid() {
        return this.$route.params.appUUID || this.appUUID;
    }
    async syncShipping() {
        this.requestOnFlight();
        this.toggleConfirm = false;
        this.updateShippingRateSyncStatus(true);
        this.shippingManagerAction('START SHIPPING RATE SYNCING');
        await this.$apollo
            .mutate({
            mutation: SyncShippingRates,
            variables: {
                input: {
                    appUuid: this.appUUID,
                },
            },
            refetchQueries: [
                {
                    query: AppShopifySetting,
                    variables: { appUUID: this.appUUID },
                },
            ],
        })
            .then(() => {
            this.shippingManagerAction('FINISH SHIPPING RATE SYNCING');
        })
            .catch((e) => {
            this.errorNotification(e.message);
            this.logError(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    get isShopify() {
        return this.bundleKey === SHOPIFY;
    }
    get tableHeaders() {
        const { headers } = this;
        if (this.isShopify) {
            headers.unshift({
                text: 'ZONE',
                value: 'zoneName',
                align: 'left',
                sortable: true,
            });
            headers.unshift({
                text: 'ORIGIN',
                value: 'origin',
                align: 'left',
                sortable: true,
            });
        }
        return headers;
    }
    get headers() {
        return [
            {
                text: 'SHIPPING METHOD',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'FEE',
                value: 'price',
                align: 'left',
                sortable: false,
                isCurrency: true,
                width: '15%',
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PUBLISHED',
                value: 'published',
                align: 'left',
                sortable: false,
                switchable: true,
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
                width: '15%',
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
                width: '10%',
            },
            {
                text: '',
                value: '',
                align: 'left',
                sortable: false,
            },
        ];
    }
    get thirdPartyFormHeader() {
        return this.thirdPartyShippingFormHeader;
    }
    updateThirdPartyShippingFormHeader(provider) {
        if (provider === ShippingMethodThirdPartyProvider.GrabExpress) {
            this.thirdPartyShippingFormHeader = 'Grab Express Activation Form';
            return;
        }
        if (provider === ShippingMethodThirdPartyProvider.Lalamove) {
            this.thirdPartyShippingFormHeader = 'Lalamove Activation Form';
            return;
        }
        if (provider === ShippingMethodThirdPartyProvider.PandaGo) {
            this.thirdPartyShippingFormHeader = 'PandaGo Activation Form';
            return;
        }
        if (provider === ShippingMethodThirdPartyProvider.NinjaVan) {
            this.thirdPartyShippingFormHeader = 'Standard Delivery by Ninja Van Form';
            return;
        }
        if (provider === ShippingMethodThirdPartyProvider.JntExpress) {
            this.thirdPartyShippingFormHeader = 'J&T Express Activation Form';
            return;
        }
        this.thirdPartyShippingFormHeader = 'Mr Speedy Activation Form';
    }
    lastSyncTextDetails(date) {
        return `Shipping Rates are updated as of ${moment(date).format('MMMM DD, YYYY hh:mm a')}`;
    }
    /**
     * Switch Value on change handler
     * Always toggle Third Party Shipping Activation Form for:
     *  non-persistent object, third party shipping and shipping w/out pickup
     *   points
     *
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.3.0}
     *
     * @param {boolean} value switch value
     * @param {ShippingMethodImpl} obj shipping method object
     *
     * @return {void} no return value
     */
    onChange(value, obj) {
        const vm = this;
        if (obj.isThirdParty && obj.pickupPoints === null) {
            if (this.isLalamoveAndHasBlankDimension(obj)) {
                this.errorNotification('Product measurements and dimensions are required to enable this feature');
                this.$nextTick(() => {
                    obj.published = !value;
                });
            }
            else {
                this.updateThirdPartyShippingFormHeader(obj.thirdPartyProvider);
                this.shippingManagerAction('START CREATE', obj.name);
                vm.$refs.activationForm.toggleForm(obj);
            }
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (this.isLalamoveAndHasBlankDimension(obj)) {
                this.errorNotification('Product measurements and dimensions are required to enable this feature');
                this.$nextTick(() => {
                    obj.published = !value;
                });
            }
            else {
                vm.$refs.shipping.togglePublishUpdate(value, obj.uuid);
            }
        }
    }
    onEdit(obj) {
        const vm = this;
        this.shippingManagerAction('START EDIT', obj.name);
        if (obj.isThirdParty) {
            if (this.isLalamoveAndHasBlankDimension(obj)) {
                this.errorNotification('Product measurements and dimensions are required to enable this feature');
            }
            else {
                this.updateThirdPartyShippingFormHeader(obj.thirdPartyProvider);
                vm.$refs.activationForm.toggleForm(obj);
            }
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (this.isLalamoveAndHasBlankDimension(obj)) {
                this.errorNotification('Product measurements and dimensions are required to enable this feature');
            }
            else {
                vm.$refs.shipping.goToShippingDetailsPage(obj.uuid);
            }
        }
    }
    allowTopup(provider) {
        return ['grab_express', 'lalamove', 'pandago', 'ninja_van', 'jnt_express'].includes(provider);
    }
    goToTopUp(key) {
        const uuid = `${key}:grab_express`;
        this.$router.push({
            name: 'ecommerce-shipping-top-up',
            params: {
                uuid,
            },
        });
    }
    isLalamoveAndHasBlankDimension(obj) {
        return ((obj.thirdPartyProvider === ShippingMethodThirdPartyProvider.Lalamove ||
            obj.thirdPartyProvider === ShippingMethodThirdPartyProvider.NinjaVan) &&
            obj.hasBlankDimension === true);
    }
    toggleRateCard(shippingName) {
        const vm = this;
        vm.$refs.rateCard.toggleForm(shippingName);
    }
    startShippingManagerCreate(shippingName) {
        this.shippingManagerAction('START CREATE', shippingName);
    }
    mounted() {
        this.viewShippingManagerPage();
    }
    toggleConfirmation() {
        this.toggleConfirm = true;
    }
    onActivate() {
        const vm = this;
        vm.$refs.jntActivationForm.toggleForm();
    }
    onDisconnect() {
        const vm = this;
        vm.$refs.jntDisconnectionForm.toggleForm();
    }
    isJntExpress(provider) {
        return provider === ShippingMethodThirdPartyProvider.JntExpress;
    }
    showActivateButton(obj) {
        return (this.isJntExpress(obj.thirdPartyProvider) &&
            this.jntAccount && // Ensure jntAccount is not null
            (this.jntAccount.validationStatus === '' ||
                this.jntAccount.validationStatus === 'failed' ||
                this.jntAccount.validationStatus === 'disconnected'));
    }
    isUnderValidation(obj) {
        return (this.isJntExpress(obj.thirdPartyProvider) &&
            this.jntAccount &&
            this.jntAccount.validationStatus === 'for_validation');
    }
    isDisconnectable(obj) {
        return (this.isJntExpress(obj.thirdPartyProvider) &&
            this.jntAccount &&
            this.jntAccount.validationStatus === 'successful');
    }
    isFailed(obj) {
        return (this.isJntExpress(obj.thirdPartyProvider) &&
            this.jntAccount &&
            this.jntAccount.validationStatus === 'failed');
    }
    isSwitchDisabled(item) {
        return ((!item.published && !item.uuid && item.shippingType !== 'third_party') ||
            (item.name === 'J&T Express' && this.jntAccount?.validationStatus !== 'successful'));
    }
    refetch() {
        if (this.shopifyShippingRateSyncing.status === false) {
            this.$apollo.queries.shopifySetting.refetch();
        }
    }
};
__decorate([
    Inject()
], ShippingMethods.prototype, "shopifyShippingRateSyncing", void 0);
__decorate([
    Inject()
], ShippingMethods.prototype, "updateShippingRateSyncStatus", void 0);
__decorate([
    Watch('shopifyShippingRateSyncing.status')
], ShippingMethods.prototype, "refetch", null);
ShippingMethods = __decorate([
    Component({
        components: {
            ActionButton,
            PageTitle,
            ShippingMethodManager,
            ShippingFormThirdParty,
            RateCard,
            AppBasicDetails,
            BaseOverlayLoader,
            ConfirmationDialog,
            JntExpressActivationForm,
            JntExpressDisconnectionForm,
        },
        apollo: {
            shopifySetting: {
                // Possible problem here: What if page is e-commerce?
                query: AppShopifySetting,
                variables() {
                    return { appUUID: this.shopifyAppUuid };
                },
                update(data) {
                    const settings = data.app.shopifySetting;
                    settings.shopifyRateSyncedAt = data.app.shopifyRateSyncedAt;
                    return settings;
                },
            },
            jntAccount: {
                query: JntDetails,
                variables() {
                    const appUuid = this.appUUID;
                    return {
                        appUuid,
                    };
                },
                update(data) {
                    return new JntAccountInputModel(data.fetchJntAccount);
                },
                subscribeToMore: {
                    document: jntAccountSubscription,
                    variables() {
                        return {
                            appGlobalId: this.$store.state.appGlobalId,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        if (!subscriptionData.data) {
                            return previousResult;
                        }
                        const updatedJntAccount = subscriptionData.data.jntAccountSubscriptionUpdate.jntAccount;
                        return {
                            ...previousResult,
                            fetchJntAccount: {
                                ...previousResult.fetchJntAccount,
                                ...updatedJntAccount,
                            },
                        };
                    },
                },
            },
        },
    })
], ShippingMethods);
export default ShippingMethods;
